import { render, staticRenderFns } from "./RoomMessage.vue?vue&type=template&id=7a7f6d18&"
import script from "./RoomMessage.vue?vue&type=script&lang=js&"
export * from "./RoomMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports